import { ADD_TO_CART, DECREMENT_QUANTITY, DELETE_ITEM, INCREMENT_QUANTITY } from "./actionTypes";



const initialState = {
    cartItems: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:

            const existingItem = state.cartItems.find(item => item.id === action.payload.id);
            if (existingItem) {
                return {
                    ...state,
                    cartItems: state.cartItems.map((item) => {
                        if (item.id === action.payload.id) {
                            return {
                                ...item,
                                quantity: item.quantity + 1
                            };
                        } else {
                            return item;
                        }
                    })
                };
            } else {
                return {
                    ...state,
                    cartItems: [...state.cartItems, action.payload]
                };
            }

        case INCREMENT_QUANTITY:

            const findItem = state.cartItems.find(item => item.id === action.payload.id);
            if (findItem) {
                return {
                    ...state,
                    cartItems: state.cartItems.map((item) => {
                        if (item.id === action.payload.id) {
                            return {
                                ...item,
                                quantity: item.quantity + 1
                            };
                        } else {
                            return item;
                        }
                    })
                };
            }
        case DECREMENT_QUANTITY:
            
            const findItem2 = state.cartItems.find(item => item.id === action.payload.id);
            if (findItem2) {
                return {
                    ...state,
                    cartItems: state.cartItems.map((item) => {
                        if (item.id === action.payload.id) {
                            if (item.quantity === 1) {
                                return null;
                            } else {
                                return {
                                    ...item,
                                    quantity: item.quantity - 1
                                };
                            }
                        } else {
                            return item;
                        }
                    }).filter(item => item !== null)    
                };
            }
        case DELETE_ITEM:
            return {
                ...state,
                cartItems: state.cartItems.filter(item => item.id !== action.payload)
            }
        default:
            return state;
    }
}

export default reducer;